import Lookup from 'src/componentes/select2';

const TelaInicial = ({ ...rest }) => (
  <Lookup
    labelKey="descricao"
    valueKey="id"
    url="/TelaInicialLookup"
    clearable={false}
    {...rest}
  />
);

export default TelaInicial;
